import metrics from "./indicator_map.json" 

const metricsMap = () => {
    return {
        data_code_series: {label: 'Data Code / Series', spark: (data_code) => `${data_code}`, input_type: 'selector', inputs: metrics},
    }
}
export {metricsMap};